import st_upload from './st_upload'

export default st_upload